import { IFlatAddOnDescriptor } from "../types";

/** internal test product */
const dummy = {
  productType: "dummy",
  kind: "flat",
  title: "Dummy",
} satisfies IFlatAddOnDescriptor;

export default dummy;
